import * as Yup from 'yup';

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

Yup.addMethod(Yup.string, 'email', function email(message?: string) {
    return this.test(
        'email',
        message || 'Please enter a valid email address',
        (value) => !value || EMAIL_REGEX.test(value),
    );
});
